import * as React from 'react';

import { CannedCollectionModule } from '@coursera-web/cds-labs';
import type { ColorChoice } from '@coursera-web/cds-labs';

import { breakpoints, useMediaQuery } from '@coursera/cds-core';

import type { PromoTemplateCannedCollectionFragment } from 'bundles/front-page/__generated__/contentfulTypes';
import normalizePromoUnitsModuleContent from 'bundles/front-page/utils/normalizePromoUnitsModuleContent';

type Props = {
  content?: PromoTemplateCannedCollectionFragment;
};

const PromoBannerModuleRenderer = ({ content }: Props) => {
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  if (!content) return null;

  const { color, showImageInFull, showAllEntries } = content;
  const normalizedItems = normalizePromoUnitsModuleContent(content);

  if (!normalizedItems.length) return null;

  return (
    <div>
      <CannedCollectionModule
        cards={normalizedItems}
        size={isMobile ? 'small' : 'large'}
        color={(color ?? 'blue') as ColorChoice}
        showImageInFull={!!showImageInFull}
        showAllEntries={!!showAllEntries}
      />
    </div>
  );
};

export default PromoBannerModuleRenderer;
